module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page-box"
  }, [_c('div', {
    staticClass: "back-box",
    on: {
      "click": _vm.back
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n    BACK\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "rev-head"
  }, [_vm._v("Review and Book")]), _vm._v(" "), _c('div', {
    staticClass: "rev-page"
  }, [_c('div', {
    staticClass: "rev-hero"
  }, [_c('img', {
    attrs: {
      "src": _vm.blockData.ProductImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-content"
  }, [_c('div', {
    staticClass: "hero-badge"
  }, [_vm._v("Attraction")]), _vm._v(" "), _c('div', {
    staticClass: "hero-title"
  }, [_vm._v(_vm._s(_vm.blockData.ProductName))]), _vm._v(" "), _c('div', {
    staticClass: "hero-meta"
  }, [(_vm.blockData.Destination) ? _c('span', [_c('i', {
    staticClass: "fas fa-map-marker-alt fa-fw"
  }), _vm._v("\n            " + _vm._s(_vm.blockData.Destination) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.blockData.Duration.trim()) ? _c('span', [_c('i', {
    staticClass: "far fa-clock fa-fw"
  }), _vm._v("\n            " + _vm._s(_vm.blockData.Duration) + "\n          ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "info-bar"
  }, [(_vm.blockData.Duration.trim()) ? _c('div', {
    staticClass: "info-card"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.blockData.Duration))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('label', [_vm._v("Booking Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.blockData.BookingDate)))])])]), _vm._v(" "), _c('div', {
    staticClass: "info-card"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_c('label', [_vm._v("Travelers")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.filters.travellers.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "rev-two-col"
  }, [_c('div', {
    staticClass: "rev-two-main"
  }, [_c('div', {
    staticClass: "section-box"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "description-text",
    domProps: {
      "innerHTML": _vm._s(_vm.blockData.GradeDescription)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "section-box"
  }, [_c('div', {
    staticClass: "sb-header"
  }, [_vm._m(4), _vm._v(" "), (_vm._token) ? _c('div', {
    staticClass: "sb-account"
  }, [_vm._v("\n              Welcome "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v("!\n              (Not "), _c('b', [_vm._v(_vm._s(_vm.user.firstName))]), _vm._v("? "), _c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('b', [_vm._v("Logout")])]), _vm._v(")\n            ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.paxForm.adult.slice(0, 1)), function(pax, p) {
    return _c('div', {
      key: p,
      staticClass: "pax-form"
    }, [_c('div', {
      staticClass: "d-flex pax-fields align-start"
    }, [_c('div', {
      class: ['pax-field', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("title" + p)) > -1
      }]
    }, [_c('div', {
      staticClass: "pax-field-label"
    }, [_vm._v("Title")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("title" + p)]),
        expression: "pax[`title${p}`]"
      }],
      staticClass: "pax-title no-outline",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          var $$exp = pax,
            $$idx = "title" + p;
          if (!Array.isArray($$exp)) {
            pax[("title" + p)] = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          } else {
            $$exp.splice($$idx, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("--")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mr"
      }
    }, [_vm._v("Mr.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Ms"
      }
    }, [_vm._v("Ms.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mrs"
      }
    }, [_vm._v("Mrs.")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Miss"
      }
    }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Mstr"
      }
    }, [_vm._v("Mstr")])])]), _vm._v(" "), _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("firstName" + p)) > -1
      }]
    }, [_vm._m(5, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("firstName" + p)]),
        expression: "pax[`firstName${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "First Name"
      },
      domProps: {
        "value": (pax[("firstName" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "firstName" + p;
          if (!Array.isArray($$exp)) {
            pax[("firstName" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]), _vm._v(" "), _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("lastName" + p)) > -1
      }]
    }, [_vm._m(6, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("lastName" + p)]),
        expression: "pax[`lastName${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "Last Name"
      },
      domProps: {
        "value": (pax[("lastName" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "lastName" + p;
          if (!Array.isArray($$exp)) {
            pax[("lastName" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])]), _vm._v(" "), (p === 0) ? _c('div', {
      class: ['pax-field fw', {
        'has-error': _vm.paxErrorFields.adult.indexOf(("email" + p)) > -1
      }],
      staticStyle: {
        "margin-bottom": "20px"
      }
    }, [_vm._m(7, true), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pax[("email" + p)]),
        expression: "pax[`email${p}`]"
      }],
      staticClass: "no-outline",
      attrs: {
        "type": "text",
        "placeholder": "Email"
      },
      domProps: {
        "value": (pax[("email" + p)])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = pax,
            $$idx = "email" + p;
          if (!Array.isArray($$exp)) {
            pax[("email" + p)] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), (p === 0) ? _c('div', {
      staticClass: "pax-field fw"
    }, [_vm._m(8, true), _vm._v(" "), _c('mobile-input', {
      staticClass: "no-outline",
      attrs: {
        "needVerification": false,
        "mobile": pax[("mobile" + p)],
        "dialCode": pax[("countryCode" + p)],
        "forPax": true,
        "uniqID": 'mobile2',
        "required": true,
        "hasError": _vm.paxErrorFields.adult.indexOf(("mobile" + p)) > -1
      },
      on: {
        "updateMobile": function($event) {
          pax[("countryCode" + p)] = $event.countryCode;
          pax[("mobile" + p)] = $event.mobile;
          _vm.highlightCheck()
        }
      }
    })], 1) : _vm._e()])
  })], 2), _vm._v(" "), (_vm.blockData.BookingQuestions && _vm.blockData.BookingQuestions.length) ? _c('div', {
    staticClass: "section-box"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "question-forms"
  }, _vm._l((_vm.blockData.BookingQuestions), function(question) {
    return _c('div', {
      staticClass: "q-field"
    }, [_c('div', {
      staticClass: "q-label"
    }, [_vm._v(_vm._s(question.subTitle.toLowerCase()))]), _vm._v(" "), _c('input', {
      staticClass: "q-value",
      attrs: {
        "type": "text"
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), _c('payment-form', {
    ref: "paymentForm",
    staticClass: "payment-form-box",
    on: {
      "done": _vm.paymentDone,
      "changeCard": _vm.changeCard
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price-section"
  }, [_c('div', {
    staticClass: "price-label"
  }, [_vm._v("Total Price")]), _vm._v(" "), _c('div', {
    staticClass: "price-value"
  }, [_vm._v("\n            " + _vm._s(_vm.currencySymbol[_vm.currency.code]) + "\n            " + _vm._s(_vm.applyCurrency(_vm.blockData.Price, false)) + " \n            "), _c('span', [_vm._v(_vm._s(_vm.currency.code))])]), _vm._v(" "), _c('div', {
    staticClass: "price-note"
  }, [_vm._v("Total for " + _vm._s(_vm.filters.travellers.total) + " traveler • Taxes included")]), _vm._v(" "), _c('button', {
    staticClass: "km-btn",
    on: {
      "click": _vm.initBook
    }
  }, [_vm._v("Book Now")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "rev-two-side"
  }, [(_vm.blockData.TM_Cancellation_Charge && _vm.blockData.TM_Cancellation_Charge.length) ? _c('div', {
    staticClass: "side-card"
  }, [_vm._m(10), _vm._v(" "), _vm._l((_vm.blockData.TM_Cancellation_Charge), function(cxl) {
    return _c('div', {
      staticClass: "c-row"
    }, [_c('span', {
      staticClass: "c-date"
    }, [_vm._v(_vm._s(_vm.cxlDate(cxl)))]), _vm._v(" "), _c('span', {
      class: ['c-fee', cxl.Charge ? 'paid' : 'free']
    }, [_vm._v(_vm._s(_vm.cxlFee(cxl)))])])
  }), _vm._v(" "), (_vm.blockData.TM_LastCancellation_date) ? _c('div', {
    staticClass: "c-deadline"
  }, [_vm._v("\n            Last free cancellation: "), _c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.blockData.TM_LastCancellation_date)))])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._m(11)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-clock fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "far fa-calendar fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fas fa-users fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("About This Experience")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-label"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-user fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("Customer Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("First name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Last name"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Email address"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pax-field-label"
  }, [_vm._v("Mobile number"), _c('span', [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sb-header"
  }, [_c('div', {
    staticClass: "sb-icon"
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('label', [_vm._v("Additional Information")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-label"
  }, [_c('i', {
    staticClass: "far fa-check-circle fa-fw"
  }), _vm._v("\n            Cancellation Policy\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-card"
  }, [_c('div', {
    staticClass: "side-label"
  }, [_vm._v("Provider Details")]), _vm._v(" "), _c('div', {
    staticClass: "supplier-row"
  }, [_c('span', {
    staticClass: "s-label"
  }, [_vm._v("Provider")]), _vm._v(" "), _c('span', {
    staticClass: "s-value"
  }, [_vm._v("FlyOver Las Vegas")])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-row"
  }, [_c('span', {
    staticClass: "s-label"
  }, [_vm._v("Supplier")]), _vm._v(" "), _c('span', {
    staticClass: "s-value"
  }, [_vm._v("HotelBeds USA, Inc")])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-row"
  }, [_c('span', {
    staticClass: "s-label"
  }, [_vm._v("Product Code")]), _vm._v(" "), _c('span', {
    staticClass: "s-value",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("E-U10-A1GMNO0129")])]), _vm._v(" "), _c('div', {
    staticClass: "supplier-row"
  }, [_c('span', {
    staticClass: "s-label"
  }, [_vm._v("Grade")]), _vm._v(" "), _c('span', {
    staticClass: "s-value"
  }, [_vm._v("TICKET1")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5997ad33", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5997ad33","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/D2DSightSeeing/review/index.vue
// module id = 2098
// module chunks = 0